export default __webpack_public_path__ + "static/media/burst1.ab9d31e4.mp3";